import {
  TransmittalDto,
  TransmittalRequestDto,
} from 'src/api/FiretrolApiClient';
import { transmittalApiClient } from 'src/api/FiretrolApiClientInstances';
import { createModuleMutations } from 'src/api/queries/workflowModules/createModuleMutations';
import { queryKeys } from 'src/api/queries/queryKeys';

const mutations = createModuleMutations<TransmittalDto, TransmittalRequestDto>({
  label: 'transmittal',
  saveOp: 'transmittal.save',
  detailKey: queryKeys.transmittals.detail,
  getId: (dto) => dto.id,
  save: (jobId, request) =>
    transmittalApiClient.createOrUpdateTransmittal(jobId, request),
  attachFromDocument: (jobId, documentId) =>
    transmittalApiClient.attachFromDocument(jobId, { documentId }),
  rotateExternalAccess: (jobId, id) =>
    transmittalApiClient.rotateExternalAccess(jobId, id),
  uploadTempFile: (file, category) =>
    transmittalApiClient.uploadTempFile(
      { data: file, fileName: file.name },
      category,
    ),
  generatePdf: (jobId, id) =>
    transmittalApiClient.generateTransmittalPdf(jobId, id),
  previewPdf: (jobId, id) =>
    transmittalApiClient.previewTransmittalPdf(jobId, id),
  logPdf: (jobId, statuses, contactId) =>
    transmittalApiClient.getTransmittalLogPdf(jobId, statuses, contactId),
});

export const useSaveTransmittal = mutations.useSave;
export const useAttachTransmittalDocument = mutations.useAttachFromDocument;
export const useUploadTransmittalTempFile = mutations.useUploadTempFile;
export const useRotateTransmittalExternalAccess =
  mutations.useRotateExternalAccess;
export const useGenerateTransmittalPdf = mutations.useGeneratePdf;
export const usePreviewTransmittalPdf = mutations.usePreviewPdf;
export const useTransmittalLogPdf = mutations.useLogPdf;
